module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_J.48d10dac.jpg";